<template>
  <div class="flex justify-center padd30t padd30b">
    <button class="btn is-btn-primary shop-button btn-block shop-payment-button" :disabled="disabled"
            @click="$emit('submit')">
      <i class="fas fa-receipt"></i> {{ __('webapp.continue_to_payment') }}
    </button>
  </div>
</template>

<script>
export default {
  props:{
    disabled: Boolean,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>

</style>